import React, {Component} from 'react'
import { Button, Modal, Form, Grid, Header, Image, Segment, Icon} from 'semantic-ui-react'
import Inputmask from "inputmask";
import { setTimeout } from 'timers';
import Spinner from './../components/Spinner';
import axios from "axios";
import '../assets/css/site.css'

import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const image = require('./../assets/images/logo.png');


/************** CONFIG TOASTER NOTIFICATION ***************************/
const CloseButton = ({ YouCanPassAnyProps, closeToast }) => (
    <i className="close icon" onClick={closeToast}></i>
  );

  const Toaster = () => (
    <ToastContainer
      closeOnClick
      hideProgressBar
      closeButton={<CloseButton YouCanPassAnyProps="foo" />}
      position={toast.POSITION.TOP_RIGHT}
    />
  );

  const dataInit = {
    CepCodigo: "",
    CodigoEstado: "",
    NomeBairro: "",
    NomeCidade: "",
    NomeEstado: "",
    NomeLogradouro: "",
    NomePais: "",
    SiglaEstado: "",
    SiglaPais: "",
    Complemento: ""
  }

export class Step1 extends Component {

    state = {
        errors: [],
        updateUser:[],
        loading: false,
        toSticker: false,
        spinner: true,
        open:false,
        cep: '',
        dataCep: dataInit
    }

   /************** STATE MODAL ***************************/
    showOpen = (size, dimmer) => () => this.setState({ size, dimmer, open: true })
    closeModal = () => this.setState({ open: false })


    /************** MENSAGE ERROR ***************************/
    mensagemError(errorString) {
        this.notify = () => toast.error(errorString, {
        autoClose: 5000,
        });
        this.notify();
    }

    /************** MENSAGE SUCCESS *************************/
    mensagemSuccess(errorString) {
        this.notify = () => toast.success(errorString);
        this.notify();
    }

    /************** FUNCTION LOADING MASK FORM ****************/
    showMask(){
        var telefone = document.getElementById("telefone");
        var maskTelefone = new Inputmask("(99) 99999-9999",{ "placeholder": "(__) _____-____" });
        maskTelefone.mask(telefone);

        var placa = document.getElementById("placa");
        var maskPlaca = new Inputmask("AAA-9[A|9]99",{ "placeholder": "___-____" });
        maskPlaca.mask(placa);

        var cpf = document.getElementById("cpf");
        var maskCPF = new Inputmask("999.999.999-99",{ "placeholder": "___.___.___-__" });
        maskCPF.mask(cpf);

        var cep = document.getElementById('cep');
        var maskCEP = new Inputmask('99999-999', {"placeholder": "_____-___"});
    }

    /************** FUNCTION LOADING MASK MODAL ****************/
    loadingMaskModal(){
        var Uplaca = document.getElementById("Uplaca");
        var maskUPlaca = new Inputmask("AAA-9[A|9]99",{ "placeholder": "___-____" });
        maskUPlaca.mask(Uplaca);

        var Ucpf = document.getElementById("Ucpf");
        var maskUCPF = new Inputmask("999.999.999-99",{ "placeholder": "___.___.___-__" });
        maskUCPF.mask(Ucpf);

    }

    /************** SEARCH USERS MODAL REQUEST *****************/
    searchUser = () => {
        try {

            var Ucpf = document.getElementById("Ucpf").value;
            var cpfString = JSON.stringify(Ucpf);
            var cpf = cpfString.replace(/[^0-9]+/g, "");


            var Uplaca = document.getElementById("Uplaca").value;
            var placaString = JSON.stringify(Uplaca);
            var placa = placaString.replace(/[^A-Z0-9]+/g, "");

            const APP_URL = process.env.REACT_APP_SEARCH_USER;

            if(cpf.length && placa.length > 0){

                axios.post(APP_URL, null, {
                    params:{
                        CPF: cpf,
                        Placa: placa,
                    },
                })
                .then(res => {
                    setTimeout(() => {
                    this.setState({ open: false });
                    this.mensagemSuccess("Solicitação Realizada com Sucesso!");
                    }, 2050)
                    this.setState({updateUser: res.data});
                    this.props.functionCallFromParent(this.state.updateUser)
                })
                .catch(error => {
                    setTimeout(() => {
                        this.setState({ open: false });
                        this.mensagemError("Por favor verifique se os dados estão corretos e tente novamente. Se persistir o erro, entre em contato com seu administrador.1");
                    }, 2050)
                });
            }else{

                this.setState({ open: false });
                this.mensagemError("Por favor verifique se todos os campos foram preenchidos corretamente, campos obrigatorios para pesquisa.");
            }

        }catch (error) {
            console.log(error)
        }
    }

    componentDidMount(){
        setTimeout(() => {
            this.setState({spinner: false});
        }, 2000)
    }



    render() {

        const {open, dimmer} = this.state
        const { loading } = this.state

        /************** LOADING MASK MODAL ***************************/
        if(this.state.open === true){
            if(this.props.acao === "i"){
                setTimeout(() => {
                    this.loadingMaskModal()
                }, 500)
            }
        }

        /************** CONFIG CSS FORM BUTTON ***************************/
        const button = {
            color: '#fff',
            backgroundColor: '#d60b52'
        }

        const buttonModal = {

            fontWeight:'700',
            marginLeft:'258px'
        }

        const magentoColor = {
            color: '#d60b52'
        }

        const select = {

            marginLeft: "-16px"
        }

        if (this.props.currentStep !== 1) {
            return null
        }
        const buttonInserOrUpdate = this.props.acao !== "i" ?  "Continuar Atualização" : "Continuar Cadastro"

        /************** LOADING MASK FORM ***************************/
        if(!this.state.spinner){
            if(this.props.acao === "i"){
                setTimeout(() => {
                    this.showMask()
                }, 500)
            }
        }

        return (

            this.state.spinner ? <Spinner/> :

            <Grid textAlign='center' style={{ height: '100vh', marginTop: '0px' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 500, width: '90vw'}}>
                <Form onSubmit={this.props.handleSubmitStep1} size='large'>
                        <Segment stacked>
                            <Header as='h2' style={magentoColor} textAlign='center'>
                                <Image style={{width: '85%', marginTop:'-10%'}} src={image} />
                                {/* <Button
                                    onClick={this.showOpen('tiny', 'blurring')}
                                    basic
                                    size="medium"
                                    type="button"
                                    style={buttonModal}>
                                    <Icon name='edit outline'/>
                                        Atualizar Cadastro
                                </Button> */}
                            </Header>
                            {/* <Form.Input
                                fluid name="nomeCondominio"
                                maxLength="50"
                                icon="building"
                                iconPosition="left"
                                placeholder="Código Condomínio"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.nomeCondominio}
                            /> */}

                            <Form.Input
                                fluid name="nomeCompleto"
                                maxLength="50"
                                icon="user"
                                iconPosition="left"
                                placeholder="Nome Completo"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.nomeCompleto}
                            />

                            <Form.Input
                                fluid name="cpf"
                                icon="address card"
                                id="cpf"
                                iconPosition="left"
                                placeholder="CPF"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.cpf}
                            />

                            <Form.Input
                                fluid name="rg"
                                maxLength="15"
                                icon="address card"
                                id="rg"
                                iconPosition="left"
                                placeholder="RG"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.rg}
                            />

                            <Form.Input
                                fluid name="cep"
                                icon="address point"
                                id="cep"
                                iconPosition="left"
                                placeholder="CEP"
                                onChange={this.props.handleChange}
                                type="text"
                                maxLength="8"
                                value={this.props.cep}
                                onBlur={this.buscarCep}
                            />

                            <Form.Input
                                fluid name="logradouro"
                                icon="address point"
                                id="logradouro"
                                iconPosition="left"
                                placeholder="Logradouro"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.dataCep.NomeLogradouro}
                            />

                            <Form.Input
                                fluid name="numero"
                                icon="address point"
                                id="numero"
                                iconPosition="left"
                                placeholder="Número"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.dataCep.numero}
                            />

                            <Form.Input
                                fluid name="complemento"
                                icon="address point"
                                id="complemento"
                                iconPosition="left"
                                placeholder="Complemento"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.dataCep.Complemento}
                            />

                            <Form.Input
                                fluid name="bairro"
                                icon="address point"
                                id="bairro"
                                iconPosition="left"
                                placeholder="Bairro"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.dataCep.NomeBairro}
                            />

                            <Form.Input
                                fluid name="cidade"
                                icon="address point"
                                id="cidade"
                                iconPosition="left"
                                placeholder="Cidade"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.dataCep.NomeCidade}
                            />

                            <Form.Input
                                fluid name="email"
                                maxLength="50"
                                icon="mail"
                                iconPosition="left"
                                placeholder="Email"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.email}
                            />

                            <Form.Input
                                fluid name="telefone"
                                id="telefone"
                                icon="phone"
                                iconPosition="left"
                                placeholder="Telefone"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.telefone}
                            />

                            <Form.Input
                                fluid name="placa"
                                id="placa"
                                icon="car"
                                iconPosition="left"
                                placeholder="Placa do Carro"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.placa}
                            />
                            {this.props.acao !== "i" ?
                                <Form.Input
                                    icon="barcode"
                                    iconPosition="left"
                                    placeholder="Código de Barra"
                                    type="text"
                                    value={this.props.updateTag}
                                />
                             :
                             ""
                            }
                            <Select
                                options={this.props.optionsMarcas}
                                onChange={this.props.inputSelectModelo}
                                value={this.props.optionsMarcas.filter(marca => marca.label === this.props.marcaCarro)}
                                placeholder={<Button basic disabled size="medium" type="button" style={select}> <Icon name='car'/> Marca</Button>}
                            />
                            <Select
                                options={this.props.optionsModelos}
                                onChange={this.props.inputSelectCor}
                                value={this.props.optionsModelos.filter(modelo => modelo.label === this.props.modeloCarro)}
                                placeholder={<Button basic disabled size="medium" type="button" style={select}> <Icon name='car'/> Modelo</Button>}
                            />

                            <Form.Input
                                fluid name="anoFabricacao"
                                id="anoFabricacao"
                                icon="car"
                                iconPosition="left"
                                placeholder="Ano de Fabricação"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.anoFabricacao}
                            />

                            <Form.Input
                                fluid name="modeloAno"
                                id="modeloAno"
                                icon="car"
                                iconPosition="left"
                                placeholder="Ano do modelo"
                                onChange={this.props.handleChange}
                                type="text"
                                value={this.props.modeloAno}
                            />

                            <Select
                                options={this.props.optionsCores}
                                onChange={this.props.inputColorSelected}
                                value={this.props.optionsCores.filter(cor => cor.label === this.props.corCarro)}
                                placeholder={<Button basic disabled size="medium" type="button" style={select}> <Icon name='car'/> Cor</Button>}
                            />
                            <Button
                                className={loading ? 'loading' : ''}
                                style={button}
                                size='medium'
                                fluid
                                icon
                                labelPosition='right'
                                >
                                <Icon name='right arrow' />
                                {buttonInserOrUpdate}
                            </Button>
                        </Segment>
                    </Form>
                    <Modal dimmer={dimmer} open={open} style={{ maxWidth: 500, width: '90vw'}}>
                        <Modal.Header>
                            <Grid.Column>
                                <Image wrapped size='small' src={image} style={{width: '35%', marginTop:'-5%', marginLeft:'-30px'}}/>
                                <h2 style={{marginLeft:'130px', marginTop:'-7%', color:'#AAAAAA'}}>Pesquisar Cadastro</h2>
                            </Grid.Column>
                        </Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <Grid textAlign='center' style={{ marginTop: '0px' }} verticalAlign='middle'>
                                    <Grid.Column style={{ maxWidth: 500, width: '50vw'}}>
                                    <Form>
                                        <Form.Input
                                        fluid name="Ucpf"
                                        icon="address card"
                                        id="Ucpf"
                                        iconPosition="left"
                                        placeholder="CPF"
                                        required
                                        type="text"
                                        />
                                        <Form.Input
                                        fluid name="UplacaCarro"
                                        id="Uplaca"
                                        icon="car"
                                        iconPosition="left"
                                        placeholder="Placa do Carro"
                                        required
                                        type="text"
                                        />
                                        <Button
                                        content='Pesquisar'
                                        icon='search'
                                        type="button"
                                        onClick={this.searchUser}
                                        labelPosition='right'
                                        fluid color='green'/>
                                    </Form>
                                    </Grid.Column>
                                </Grid>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                onClick={this.closeModal}
                                color='brown'>
                                <Icon name='cancel' />
                                    Fechar &nbsp;
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </Grid.Column>
            </Grid>
        )
    }
}


export default Step1;